<div class="newBox" *ngIf="isNew">
  {{ "InventoryCard.NewBox" | translate }}
</div>
<div class="inventoryBox mat-elevation-z4">
  <div class="flex flex-space-between">
    <div *ngIf="localDateFormat === 'en-US'" class="mat-body-1">
      {{ "InventoryCard.Received" | translate }}:
      {{ received | date: "M/dd/yyyy" }}
    </div>
    <div *ngIf="localDateFormat !== 'en-US'" class="mat-body-1">
      {{ "InventoryCard.Received" | translate }}:
      {{ received | date: "yyyy/M/dd" }}
    </div>
    <div>{{ "InventoryCard.Amount" | translate }}: {{ amount }}</div>
  </div>
  <br />
  <div>{{ "InventoryCard.From" | translate }}: {{ from }}</div>
</div>
